import { Suspense } from 'react'
import events from '~/features/GrowthEvent'
import type { DynamicGrowthEvents } from '../growthEventConfig'
import { useGrowthEventState } from './useGrowthEventState'

export default function LoadGrowthEvents() {
  return (
    <Suspense>
      {events.map(event => (
        <RenderEventSlotContents key={event.id} eventId={event.id} />
      ))}
    </Suspense>
  )
}

function RenderEventSlotContents({
  eventId,
}: {
  eventId: keyof DynamicGrowthEvents
}) {
  const { SlotContents, isEnabled } = useGrowthEventState(eventId)

  return SlotContents && isEnabled && <SlotContents />
}
